module.exports = __webpack_public_path__ + "static/media/ryan-hassan.79f8c8d1.jpg";